  const smartTrim = value => {
    let smartTrimed = value;
    smartTrimed = smartTrimed.replace(/^\s+/g, '');
    smartTrimed = smartTrimed.replace(/\s{2,}$/, ' ');
    return smartTrimed;
  };

  export default smartTrim;
